<template>
    <div class="profiles">
        <div>
            <div class="park_introduce">
                <div class="title">园区介绍</div>
                <div class="introduce clearfix">
                    <div class="shortText" v-if="!moreText">
                        {{ parkData ? parkData.introduce : '' }}
                    </div>
                    <div v-else>{{ parkData ? parkData.introduce : '' }}</div>
                    <span class="showMore">
                      <a v-if="!moreText" @click="moreText = !moreText">
                        展开
                        <i class="icon moreDown_icon"></i>
                      </a>
                      <a v-else @click="moreText = !moreText">收起</a>
                    </span>
                </div>
                <div class="line" style="margin-top: 22px;"></div>
            </div>
        </div>
        <div class="park_mien" style="margin-top: 44px;">
            <div class="title">园区风采</div>
            <div class="photos">
                <img class="photos_item" v-gallery:organizationDesc
                     v-for="(item, i) in parkData ? parkData.imgList : []"
                     :key="i" :src="item" :alt="item"
                />
            </div>
        </div>
        <div style="margin-top: 36px">
            <div class="infoRow clearfix">
                <div class="fl infoKey">联系方式</div>
                <div class="fr infoValue">{{ parkData ? parkData.phone : '' }}</div>
            </div>
            <div class="infoRow clearfix">
                <div class="fl infoKey">联系邮箱</div>
                <div class="fr infoValue">{{ parkData ? parkData.email : '' }}</div>
            </div>
            <div class="infoRow clearfix">
                <div class="fl infoKey">园区地址</div>
                <div class="fr infoValue">
                    <i class="icon greyLocationIcon size16 alignM"></i>
                    {{ parkData ? parkData.province : '' }}
                    {{ parkData ? parkData.city : '' }}
                    {{ parkData ? parkData.area : '' }}
                    {{ parkData && parkData.address ? parkData.address : '' }}
                </div>
            </div>

        </div>

        <div style="margin-top: 30px">
            <router-link to="/myPark/edit" class="button block yellowButton" style="padding: 0;
                                        line-height: 42px; height: 42px; border-radius: 20px;">
                修改资料
            </router-link>
        </div>
    </div>
</template>

<script>

import Vue from "vue";
import gallery from "img-vuer";

Vue.use(gallery, {
    swipeThreshold: 150, // default 100
    isIndexShow: true, // show image index, default true
    useCloseButton: true, // trigger gallery close with close button, default true
    preload: true, // preload images in the same group, default true
    sliderBackgroundColor: "rgba(0,0,0,0.6)",
    sliderZIndex: 1001,
});

export default {
    name: "myParkProfiles",
    props : {
        parkData : Object
    },
    data() {
        return {
            moreText: false,
            organizationDesc : 'organizationDesc'
        }
    }
}
</script>

<style lang="scss" scoped>

.park_introduce {

    .title {
        font-size: 18px;
        font-weight: 500;
        line-height: 19px;
        color: #333333;

    }

    .introduce {
        margin-top: 9px;
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
        color: #8994a9;

        .shortText {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
        }

        .showMore {
            float: right;
            bottom: 10px;
            font-size: 13px;
            font-weight: 400;
            line-height: 19px;
            color: #ffb950;
        }
    }
}

.park_mien {
    margin-top: 21px;

    .title {
        //width: 72px;
        //height: 25px;
        font-size: 18px;
        font-weight: 500;
        line-height: 19px;
        color: #333333;
    }

    .photos {
        margin-top: 12px;
        display: flex;
        -ms-overflow-style: none;
        scrollbar-width: none;
        overflow-x: auto;

        .photos_item {
            width: 122px;
            height: 76px;
            background: rgba(0, 0, 0, 0);

            border-radius: 4px;
            margin-right: 12px;
        }
    }
}

.infoRow {
    padding: 9px 0;

    .infoKey {
        color: hsla(0, 0%, 20%, 1);
        font-size: 100%;
    }

    .infoValue {
        color: hsla(219, 16%, 60%, 1);
        font-size: 87.5%;
    }
}
</style>
